export default "__VITE_PUBLIC_ASSET__b8d4e092__"